import { useMutation, useQueryClient, type UseMutationResult } from "@tanstack/react-query";
import { useAuth } from "@/auth/AuthContext";
import { createApiClient } from "@/api/client";
import { queryKeys } from "@/api/queryClient";
import type { Agent } from "@/types";

// #244: Outbound-Relay-Policy setzen. PATCH /agents/:id/relay-mode (Owner/Admin).
// Multi-Select: final + verbose unabhängig. Beide aus = heutiges Verhalten (nur mesh__send).
// Invalidiert ["resources","agents"].

function useRelayModeClient() {
  const { session, logout } = useAuth();
  return () =>
    createApiClient({
      getToken: () => session?.accessToken ?? null,
      onUnauthorized: logout,
    });
}

export interface RelayModePatch {
  final?: boolean;
  verbose?: boolean;
}

export function useUpdateRelayMode(
  agentId: string,
): UseMutationResult<Agent, Error, RelayModePatch> {
  const qc = useQueryClient();
  const getClient = useRelayModeClient();
  return useMutation({
    mutationFn: (patch) => getClient().patch<Agent>(`/agents/${agentId}/relay-mode`, patch),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.resource("agents") }),
  });
}
